import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/layout/MainLayout';
import { LoginPage, ProtectedRoute } from './components/auth';
import { Dashboard } from './pages/Dashboard';
import { Planning } from './pages/Planning';
import { Configuration } from './pages/Configuration';
import { Analytics } from './pages/Analytics';

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<Navigate to="/dashboard" replace />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/planning" element={<Planning />} />
                <Route path="/configuration" element={<Configuration />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/settings" element={<Configuration />} />
                <Route path="/settings/*" element={<Configuration />} />
                
                {/* Admin routes */}
                <Route
                  path="/admin/*"
                  element={
                    <ProtectedRoute requiredRoles={['admin']}>
                      <Routes>
                        <Route path="/users" element={<div>User Management</div>} />
                        <Route path="/system" element={<div>System Settings</div>} />
                      </Routes>
                    </ProtectedRoute>
                  }
                />
                
                {/* 404 */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;